import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { getPaddingPropsBySpacing } from '../../utils/styling/StylingHelper'
import { NonFlexingContainerProps } from '../NonFlexingContainer'

export type FlexingContainerProps = NonFlexingContainerProps & {
    flexGrow?: number
}

const FlexingContainer: FunctionComponent<FlexingContainerProps> = ({
    children,
    innerRef,
    flexGrow = 1,
    spaceX,
    spaceY,
    spaceLeft,
    spaceRight,
    spaceBottom,
    spaceTop,
    ...rest
}): ReactElement => {
    return (
        <Grid
            ref={innerRef}
            pointer={false}
            flexGrow={flexGrow}
            {...getPaddingPropsBySpacing({
                spaceX,
                spaceY,
                spaceLeft,
                spaceRight,
                spaceBottom,
                spaceTop,
            })}
            {...rest}
        >
            {children}
        </Grid>
    )
}

export default FlexingContainer
